import {translate} from '../helpers';

const showDeliveryType = (deliverType: string) => {
  if (['CHAPAR', 'COURIER', 'EXPRESS_POST', 'POST'].includes(deliverType)) {
    return 'عادی';
  }
  return translate(deliverType);
};

export default showDeliveryType;
